import {createAction} from "@reduxjs/toolkit";
import {DVIRSearchCriteria} from "@ots-frontend/ots-data";

export const setUIDVIRSearchFilter = createAction<DVIRSearchCriteria>("ots-ui/dvir/setSearchFilter");
